import React from "react";
import "./Shop.css";

const products = [
  {
    id: 1,
    title: "NBA",
    images: [
      "/home_data/shop/NBA/NBA_3.png",
      "/home_data/shop/NBA/NBA_2.jpg",
      "/home_data/shop/NBA/NBA_1.jpg",
    ],
    link: "https://www.amazon.com/stores/page/4F17A344-9786-460A-A258-177FFD1CAA76",
  },
  {
    id: 2,
    title: "NHL",
    images: [
      "/home_data/shop/NHL/NHL_1.png",
      "/home_data/shop/NHL/NHL_2.jpeg",
      "/home_data/shop/NHL/NHL_3.jpg",
    ],
    link: "https://www.amazon.com/stores/page/252C32D7-91C2-4DA9-A321-092990574B0D",
  },
  {
    id: 3,
    title: "GAME 7",
    images: [
      "/home_data/shop/GAME7/GAME7_1.png",
      "/home_data/shop/GAME7/GAME7_3.jpg",
      "/home_data/shop/GAME7/GAME7_2.jpg",
    ],
    link: "https://www.amazon.com/stores/page/D3F9AE28-D3FB-4746-9CCE-992BE223A148",
  },
  {
    id: 4,
    title: "NEW",
    images: [
      "/home_data/shop/NEW/NEW_2.png",
      "/home_data/shop/NEW/NEW_1.jpg",
      "/home_data/shop/NEW/NEW_3.jpg",
    ],
    link: "https://www.amazon.com/stores/page/A95BC736-97A9-4369-95AD-EAFBB13394A2",
  },
];

const Shop = () => {
  return (
    <section className="shop">
      <div className="shopContent">
        <h2 className="shopTitle">
          WHERE THE
          <br />
          GAME LIVES ON.
        </h2>
        <p className="shopSubtitle">OFFICIALLY LICENSED GEAR</p>
      </div>

      <div className="shopProducts">
        {products.map((product) => (
          <a
            key={product.id}
            href={product.link}
            className="shopCard"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Shop ${product.title}`}
          >
            <div className="shopImageWrapper">
              <img
                src={product.images[0]}
                alt={product.title}
                className="shopImage base"
              />
              <img
                src={product.images[1]}
                alt={product.title}
                className="shopImage hover"
              />
            </div>

            <div className="shopCardOverlay">
              <div className="shopText">
                <h5 className="shopCategory">{product.title}</h5>
                <p className="shopNow">SHOP NOW</p>
              </div>
              <span className="arrow">↗</span>
            </div>
          </a>
        ))}
      </div>

      <a
        href="https://www.amazon.com/game7"
        className="shopButton"
        target="_blank"
        rel="noopener noreferrer"
      >
        SHOP NOW
      </a>
    </section>
  );
};

export default Shop;

// test